// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"AssetList_skeletonWrapper__9sozK"};